/*
 * Snyvia: product image hover zoom (desktop only).
 * Hovering the main product image shows a lens box on the image and a magnified
 * preview panel beside it. Mobile/touch devices are untouched.
 */
(() => {
  const ZOOM = 2.5; // magnification in the preview panel
  const GAP = 16; // space between image and panel, and panel and viewport edge
  const MIN_PANEL = 280; // don't show the panel if there's less room than this
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const GALLERY = '.product-information__media';

  const style = document.createElement('style');
  style.textContent = `
    ${GALLERY} .product-media img { cursor: crosshair; }
    .snyvia-zoom-lens, .snyvia-zoom-pane { position: fixed; pointer-events: none; display: none; z-index: 1000; }
    .snyvia-zoom-lens { border: 1px solid rgba(0,0,0,.55); background: rgba(255,255,255,.25); box-sizing: border-box; }
    .snyvia-zoom-pane { background: #fff no-repeat; box-shadow: 0 4px 24px rgba(0,0,0,.12); }
  `;
  document.head.appendChild(style);

  const lens = document.createElement('div');
  lens.className = 'snyvia-zoom-lens';
  const pane = document.createElement('div');
  pane.className = 'snyvia-zoom-pane';
  document.body.append(lens, pane);

  let activeImg = null;

  const hide = () => {
    lens.style.display = pane.style.display = 'none';
    activeImg = null;
  };

  // Largest useful image from Shopify's CDN (width param bumped), falling back to what's loaded.
  const hiRes = (img) => {
    const src = img.currentSrc || img.src;
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$12400') : src;
  };

  // Rectangle the image content actually occupies inside the <img> box (handles object-fit cover/contain).
  const contentBox = (img, box) => {
    const nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return { x: 0, y: 0, w: box.width, h: box.height };
    const fit = getComputedStyle(img).objectFit;
    const s = fit === 'contain' ? Math.min(box.width / nw, box.height / nh)
            : fit === 'cover' ? Math.max(box.width / nw, box.height / nh)
            : null;
    if (s === null) return { x: 0, y: 0, w: box.width, h: box.height }; // 'fill' etc.
    const w = nw * s, h = nh * s;
    return { x: (box.width - w) / 2, y: (box.height - h) / 2, w, h };
  };

  const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), Math.max(lo, hi));

  document.addEventListener('mousemove', (e) => {
    if (!desktop.matches) return hide();
    const img = e.target.closest?.(`${GALLERY} .product-media img`);
    if (!img || !img.complete) return hide();

    const box = img.getBoundingClientRect();
    const c = contentBox(img, box);

    // Visible part of the image (cover can overflow the box; the viewport can cut it too).
    const visTop = Math.max(box.top, 0), visBottom = Math.min(box.bottom, window.innerHeight);

    // Panel beside the image: right if there's room, otherwise left.
    const roomRight = window.innerWidth - box.right - GAP * 2;
    const roomLeft = box.left - GAP * 2;
    const right = roomRight >= roomLeft;
    const paneW = Math.min(box.width, right ? roomRight : roomLeft);
    const paneH = Math.max(0, visBottom - visTop - GAP * 2);
    if (paneW < MIN_PANEL || paneH < MIN_PANEL) return hide();
    const paneX = right ? box.right + GAP : box.left - GAP - paneW;
    const paneY = visTop + GAP;

    // Lens = the area of the image shown in the panel, centred on the cursor and kept inside the image.
    const lw = paneW / ZOOM, lh = paneH / ZOOM;
    const minX = Math.max(0, c.x), maxX = Math.min(box.width, c.x + c.w);
    const minY = Math.max(0, c.y, visTop - box.top), maxY = Math.min(box.height, c.y + c.h, visBottom - box.top);
    const lx = clamp(e.clientX - box.left, minX + lw / 2, maxX - lw / 2);
    const ly = clamp(e.clientY - box.top, minY + lh / 2, maxY - lh / 2);

    if (img !== activeImg) {
      activeImg = img;
      pane.style.backgroundImage = `url("${hiRes(img)}")`;
    }

    Object.assign(lens.style, {
      display: 'block',
      width: `${lw}px`, height: `${lh}px`,
      left: `${box.left + lx - lw / 2}px`, top: `${box.top + ly - lh / 2}px`,
    });
    Object.assign(pane.style, {
      display: 'block',
      width: `${paneW}px`, height: `${paneH}px`,
      left: `${paneX}px`, top: `${paneY}px`,
      backgroundSize: `${c.w * ZOOM}px ${c.h * ZOOM}px`,
      backgroundPosition: `${-((lx - c.x) * ZOOM - paneW / 2)}px ${-((ly - c.y) * ZOOM - paneH / 2)}px`,
    });
  }, { passive: true });

  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
  document.addEventListener('mouseleave', hide);
})();
